import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { FormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { ItemListComponent } from './icms/item-list/item-list.component';
import { ItemService } from './icms/item.service';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { CurrentUserComponent } from './current-user/current-user.component';
import { AuthService } from './services/auth.service';
import { ArtieSaysComponent } from './artie-says/artie-says.component';
import { RolodexComponent } from './icms/rolodex/rolodex.component';
import { ItemCardComponent } from './icms/item-card/item-card.component';
import { ButtonComponent } from './icms/button/button.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AboutComponent } from './about/about.component';

@NgModule({
  declarations: [
    AppComponent,
    ItemListComponent,
    CurrentUserComponent,
    ArtieSaysComponent,
    RolodexComponent,
    ItemCardComponent,
    ButtonComponent,
    PrivacyComponent,
    AboutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    NgbModule
  ],
  providers: [AuthService, CurrentUserComponent, ItemService, ItemListComponent, ArtieSaysComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
